export default "__VITE_ASSET__251d0933__"